import React, { useEffect } from 'react';
import { Card, CardBody, CardHeader, Table, Spinner, Container } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { getLanguages } from '../../slices/language/thunk';
import BreadCrumb from '../../Components/Common/BreadCrumb';

const Language = () => {
    document.title = "Languages | Koottu Admin";
    const dispatch = useDispatch();

    const { languages, loading, error } = useSelector((state) => ({
        languages: state.Language.languages,
        loading: state.Language.loading,
        error: state.Language.error
    }));

    useEffect(() => {
        dispatch(getLanguages());
    }, [dispatch]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                <Spinner color="primary" />
            </div>
        );
    }

    if (error && error.message) {
        return (
            <div className="alert alert-danger" role="alert">
                Error loading languages: {error.message}
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Language" pageTitle="Settings" />
                    <Card>
                        <CardHeader>
                            <h4 className="card-title mb-0 flex-grow-1">Languages</h4>
                        </CardHeader>
                        <CardBody>
                            <div className="table-responsive">
                                <Table className="table-bordered align-middle table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Language</th>
                                            <th scope="col">Language Code</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(languages) && languages.map((lang) => (
                                            <tr key={lang.id}>
                                                <td>{lang.language}</td>
                                                <td>{lang.languageCode}</td>
                                                <td>
                                                    <span className={`badge ${lang.status === 1 ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                                                        {lang.statusMsg}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                        {Array.isArray(languages) && languages.length === 0 && (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    No languages found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Language;